// extracted by mini-css-extract-plugin
module.exports = {"icon":"GlossaryHint_icon__JXYat"};